// Counts the work the user is actually waiting on - API requests and route
// chunk loads - for the top progress bar (TopProgressBar.js).
//
// Live-update re-reads are deliberately NOT counted: they happen in the
// background on every till whenever anything changes anywhere, and a bar
// flashing across every screen on every sale would be noise, not feedback.
import { isWithinLiveRefresh } from "../../realtime/liveSocket";

let active = 0;
const listeners = new Set();

const emit = () => listeners.forEach((listener) => listener(active));

export const subscribeLoading = (listener) => {
  listeners.add(listener);
  listener(active);
  return () => listeners.delete(listener);
};

export const startLoading = () => {
  active += 1;
  emit();
  let done = false;
  // Returns its own "end" so a double call can't drive the count negative.
  return () => {
    if (done) return;
    done = true;
    active = Math.max(0, active - 1);
    emit();
  };
};

// Hooks an axios instance into the tracker. Opt a single request out with
// `{ trackLoading: false }` in its config.
export const trackAxios = (instance) => {
  instance.interceptors.request.use((config) => {
    if (config.trackLoading !== false && !isWithinLiveRefresh()) {
      config.__endLoading = startLoading();
    }
    return config;
  });
  instance.interceptors.response.use(
    (response) => {
      response?.config?.__endLoading?.();
      return response;
    },
    (error) => {
      error?.config?.__endLoading?.();
      return Promise.reject(error);
    }
  );
};
